/* eslint-disable @typescript-eslint/no-unused-vars */
'use client'

import dynamic from 'next/dynamic';
const PageContainer = dynamic(() => import('@/components/common/page-container'), { ssr: false });
const PackageListContainer = dynamic(() => import('@/components/pages/packages/package-list-container'), { ssr: false });
const PlansContainer = dynamic(() => import('@/components/pages/packages/plans-container'), { ssr: false });
import Grid from '@mui/material/Grid2';
import { PackageProvider, usePackageContext } from '@/context/package';
import { Alert } from "@mui/material";
import ServiceListContainer from "@/components/pages/packages/service-list-container";
import React, { useState } from 'react';
import { useTranslations } from 'next-intl';
import '@/components/styles/packages.scss';
import {Rfs__packages} from "../../../../_refs/Rfs__packages";
import '@/components/styles/common.scss';
import '@/components/styles/common-packages.scss';

type TabType = 'admissions' | 'funding' | 'visa';

Rfs__packages.PageContent();

function PageContent() {
    const { error, loading } = usePackageContext();
    const [activeTab, setActiveTab] = useState<TabType>('funding');
    const tPackage = useTranslations('packages');

    const handleTabClick = (tab: TabType) => {
        setActiveTab(tab);
    };

    if (error) {
        return (
            <PageContainer>
                <Grid container justifyContent="center" sx={{ width: 1 }}>
                    <Alert severity="error">
                        {error}
                    </Alert>
                </Grid>
            </PageContainer>
        );
    }

    return (
        <PageContainer>

            <div className="banner_packages head">
                <div className="container">
                    <div className="subtitle">{tPackage('bannerTxt1',{ name: activeTab })}</div>
                    <div className="title">{tPackage('bannerTxt2',{ name: activeTab.charAt(0).toUpperCase() + activeTab.slice(1) })}</div>
                </div>
                <div className="oc-cubics">
                    <img className="container2" src="/packages/banner_packages.svg" />
                </div>
            </div>

            <Grid
                paddingY={{ lg: 4, sm: 3, md: 3, xs: 3 }}
                container
                spacing={{ lg: 4, sm: 3, md: 3, xs: 3 }}
            >
                {/* Tab Navigation */}
                <Grid size={12} className={'__Packages PackageListContainer'}>
                    <div className="tabs-packages">
                        <button
                            className={`EachTapPackage Tab-Admissions ${activeTab === 'admissions' ? 'selected' : ''}`}
                            onClick={() => handleTabClick('admissions')}
                        >
                            <span className="admissions">{tPackage('navigation.tabs.admissions')}</span>
                        </button>
                        <button
                            className={`EachTapPackage Tab-Funding ${activeTab === 'funding' ? 'selected' : ''}`}
                            onClick={() => handleTabClick('funding')}
                        >
                            <span className="funding">{tPackage('navigation.tabs.funding')}</span>
                        </button>
                        <button
                            className={`EachTapPackage Tab-Visa ${activeTab === 'visa' ? 'selected' : ''}`}
                            onClick={() => handleTabClick('visa')}
                        >
                            <span className="visa">{tPackage('navigation.tabs.visa')}</span>
                        </button>
                    </div>
                </Grid>

                {/* Content based on active tab */}
                {activeTab === 'admissions' && <PackageListContainer activeTab={activeTab} />}
                {activeTab === 'funding' && (
                    <>
                        <PackageListContainer activeTab={activeTab} />
                        <ServiceListContainer activeTab={activeTab} />
                    </>
                )}
                {activeTab === 'visa' && <ServiceListContainer activeTab={activeTab} />}

                {activeTab !== 'funding' && activeTab !== 'visa' &&<PlansContainer/>}

            </Grid>



        </PageContainer>
    );
}

export default function Page() {
    return (
        <PackageProvider>
            <PageContent />
        </PackageProvider>
    );
}
